<template>
  <BaseTemplate class="bg_white pb48">
    <div>
      <router-view></router-view>
    </div>
  </BaseTemplate>
</template>

<script>
export default {
  name: 'Keepgoing'
}
</script>



// WEBPACK FOOTER //
// src/views/keepgoing/route.vue